import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=a0f4c6ba"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0f4c6ba')) {
      api.createRecord('a0f4c6ba', component.options)
    } else {
      api.reload('a0f4c6ba', component.options)
    }
    module.hot.accept("./Suppliers.vue?vue&type=template&id=a0f4c6ba", function () {
      api.rerender('a0f4c6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Suppliers.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Suppliers.vue
// module id = 144
// module chunks = 0